import * as React from 'react';

import * as styles from './CallUnderDescriptionBannerLayoutRedesigned.css';

export const CallUnderDescriptionBannerLayoutRedesigned: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
